export default [
    {
        text: 'ID',
        value: 'id',
    },
    {
        text: 'nombre subfamilia',
        value: 'subfamily',
    },
    {
        text: 'nombre familia',
        value: 'wh_family_name',
        component: {
            custom: 'wh_family_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'families_list',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Familias',
            },
        },
    },
]
